<template>
  <v-card class="sigfloMenuCard sigfloNeutralBorder150 elevation-0" width="335">
    <v-btn x-large icon class="closeButton" @click="$emit('close-dialog')"><v-icon>mdi-close</v-icon></v-btn>
    <v-card-text>
      <v-expansion-panels class="">
        <v-expansion-panel v-for="message in sigfloMessages" :key="message.id">
          <v-expansion-panel-header class="sigfloBody600">
            {{ message.label }}
          </v-expansion-panel-header>
          <v-expansion-panel-content class="sigfloBodySmall300">
            {{ message.message }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      sigfloMessages: {
        type: Array,
        required: false
      }
    }
  };
</script>

<style scoped>
  .closeButton {
    position: absolute;
    right: 25px;
    top: 25px;
  }
  .theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #f9f6fd;
    color: rgba(0, 0, 0, 0.87);
  }
  .v-expansion-panel::before {
    box-shadow: none !important;
  }
</style>
